import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { List, Any } from './BaseData.js';
import { RenderControlData } from './RenderControlData.js';

const COURSE_OUTCOMES_EXAMPLE = {
  mainTitle: "By the end of this course you will...",
  outcomes: [
    {
      image: "/outcomes_first_01.png",
      title: "Learn the AI Art Industry",
      description: "Explore major players, technologies, and processes."
    },
    {
      image:"/outcomes_middle_01.png",
      title: "Complete Your First AI Project",
      description: "Hands-on experience with leading AI models."
    },
    {
      image: "/outcomes_last_01.png",
      title: "Stay Ahead in AI Media:",
      description: "Follow aggregators and use the latest technologies."
    }
  ]
};

const CourseOutcomes = ({ section }) => {
  const {
    mainTitle = COURSE_OUTCOMES_EXAMPLE.mainTitle,
    outcomes = COURSE_OUTCOMES_EXAMPLE.outcomes,
  } = section || {};

  return (
    <section className="py-4 w-100" style={{ }}>
      <Container>
        {/* Main title for the section */}
        <Row className="mb-3">
          <Col>
            <h2 className="text-center display-2 mt-3 mb-5" >
              {mainTitle}
            </h2>
          </Col>
        </Row>
        {/* Grid for the outcome cards */}
        <Row className="g-4 justify-content-center">
          {outcomes.map((outcome, index) => (
            <Col key={index} md={6} lg={4} className="d-flex">
              {/* Card for each outcome */}
              <Card className="rounded-0 h-100 border-0 bg-transparent shadow-none text-center">
                {/* Image at the top of the card */}
                   <div className="ratio ratio-16x9 w-75 mx-auto">
                  <Card.Img
                    variant="top"
                    src={outcome.image}
                    className="rounded-4 w-100 h-80"
                    style={{ objectFit: 'cover' }}
                    alt={outcome.title}
                  />
                </div>
                {/* Card body with title and description */}
                <Card.Body className="p-4 d-flex flex-column align-items-center">
                  <Card.Title className="fw-bold mb-3" style={{ fontSize: '1.5rem', color: '#212529' }}>
                    {outcome.title}
                  </Card.Title>
                  <Card.Text
                    className="flex-grow-1"
                    style={{
                      fontSize: '1.1rem',
                      lineHeight: '1.6',
                      color: '#6c757d'
                    }}
                  >
                    {outcome.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {/* "Explore All Courses" Button */}
        <Row className="mt-5 justify-content-center">
          <Col xs="auto">
            <Button
              href="https://www.eventbrite.ca/e/making-ai-useful-to-creatives-and-agencies-tickets-1859345254709"
              className="rounded-3 px-5 py-2"
              style={{
                backgroundColor: '#FDFBF1',
                color: '#212529',
                fontWeight: 'bold',
                fontSize: '1.1rem',
                border: '1px solid #212529'
              }}
            >
              explore all courses
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

class CourseOutcomesData extends RenderControlData {
  static annotations = Object.assign({}, RenderControlData.annotations, {
    mainTitle: String,
    outcomes: List(Any),
  });

  constructor(data = {}) {
    super(data);
    this.outcomes = data.outcomes || [];
  }
}

export { CourseOutcomes, CourseOutcomesData };
export default CourseOutcomes;